export enum AppRoute {
    CITY_PREFIX = "city/:city",
    LISTING = "listing/:listing_id",
    APPLICATION_CREATE = "application/:application_id",
}
